interface TimeSlotButtonProps {
  time: string;
  isSelected: boolean;
  isAvailable: boolean;
  onSelect: () => void;
}

export default function TimeSlotButton({
  time,
  isSelected,
  isAvailable,
  onSelect
}: TimeSlotButtonProps) {
  return (
    <button
      onClick={onSelect}
      disabled={!isAvailable}
      className={`px-4 py-3 rounded-lg text-sm font-medium transition-all duration-smooth ${
        !isAvailable
          ? 'bg-muted text-muted-foreground cursor-not-allowed opacity-50'
          : isSelected
            ? 'bg-primary text-primary-foreground'
          : 'bg-card border-2 border-border text-foreground hover:border-primary hover:bg-primary/10'
      }`}
    >
      {time}
    </button>
  );
}